
export enum LANG_ACTION_TYPE {
  CHANGE_LANGUAGE = 'CHANGE_LANGUAGE',
}

export type ChangeLanguageAction = {
  type: LANG_ACTION_TYPE.CHANGE_LANGUAGE;
  payload: { data: any };
};

export type LangActions = ChangeLanguageAction;
